import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import WorkspaceDashboard from "../../components/WorkspaceDashboard";

const OverviewDashboardPage = () => {
  const companyId = useSelector(
    state => state.api.currentViewer.viewer.companyId
  );
    
  const location = useLocation();
  const route = location.pathname == "/" ? null : location.pathname;

  return <WorkspaceDashboard companyId={companyId} route={route }/>;
};

export default OverviewDashboardPage;
